import React from "react"
import visa from "../../assets/payments-icons/visa.svg"
import mastercard from "../../assets/payments-icons/mastercard.svg"
import maestro from "../../assets/payments-icons/maestro.svg"
import ae from "../../assets/payments-icons/ae.svg"
import cb from "../../assets/payments-icons/cb.svg"
import unknown from "../../assets/payments-icons/unknown.svg"
import discover from "../../assets/payments-icons/discover.svg"
import jcb from "../../assets/payments-icons/jcb.svg"
import union from "../../assets/payments-icons/union.svg"
import "./styles.scss"

export const CardsWeAccept = () => {
  return (
    <>
      <div id="cards-we-accept">
        <img src={visa} alt="visa" className="payment-card" />
        <img src={mastercard} alt="mastercard" className="payment-card" />
        <img src={maestro} alt="maestro" className="payment-card" />
        <img src={ae} alt="american express" className="payment-card" />
        <img src={cb} alt="cartes bancaires" className="payment-card" />
        <img src={unknown} alt="diners club" className="payment-card" />
        <img src={discover} alt="discover" className="payment-card" />
        <img src={jcb} alt="jcb" className="payment-card" />
        <img src={union} alt="union pay" className="payment-card" />
      </div>
    </>
  )
}
